import { Card, CardBody ,Typography} from "@material-tailwind/react";
import { CheckCircle } from "lucide-react";
import '../styles/lines.css';

const ComplianceSection = () => {
    const complianceItems = [
        "Code Audit",
        "End-to-End Encryption",
        "Continuous Integration and Continuous Deployment (CI/CD)",
        "ISO/IEC 27001:2013",
        "OWASP Top 10 - Vital web-vulnerabilities that must be checked",
        "Security Audit - Cybersecurity assessment, smart contracts audit, penetration testing",
    ];

    return (
        <div className="flex flex-col md:flex-row items-start gap-8 p-8 bg-white">
            <div className="flex-1">
                <div className="flex items-center gap-2 mb-4">
                    <div ><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 66 74" fill="none"><path id="Vector" d="M2.59026 19.4326L33.17 36.9997M33.17 36.9997L63.0993 19.4331M33.17 36.9997L33.1702 72.1342M2.59009 19.4426L33.0445 1.86572L63.41 19.3931V54.4479L33.0445 71.972L2.67912 54.4479L2.59009 19.4426Z" stroke="#96226E" stroke-width="3.25832" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    </div>
                </div>
                <h2 className="text-3xl xl:text-4xl font-bold font-poppins mb-4">Compliance by Default</h2>
                <p className=" text-xl lg:3xl font-poppins text-gray-600">We follow the highest, established industry standards</p>
            </div>

            <Card className="flex-1 bg-[#29293e] text-white p-6 rounded-2xl font-poppins shadow-xl">
            
                <CardBody className="space-y-4">
                    {complianceItems.map((item, index) => (
                        <div key={index} className="flex items-start gap-4">
                            <CheckCircle className="text-[#037AC0]" size={24} />
                            <Typography className="w-full font-poppins "> {item} </Typography>
                        </div>
                    ))}
                </CardBody>
            </Card>
        </div>
    );
};

export default ComplianceSection;
